import { render, staticRenderFns } from "./Consignment.vue?vue&type=template&id=34ff18ce&scoped=true&"
import script from "./Consignment.vue?vue&type=script&lang=js&"
export * from "./Consignment.vue?vue&type=script&lang=js&"
import style0 from "./Consignment.vue?vue&type=style&index=0&id=34ff18ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ff18ce",
  null
  
)

export default component.exports